var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-list',[_c('f7-list-item',{ref:"list",class:_vm.type,attrs:{"title":_vm.label,"smart-select":"","smart-select-params":{
      openIn: 'popup',
      searchbar: true,
      searchbarPlaceholder: 'Search',
    }}},[_c('select',{ref:"item",attrs:{"name":_vm.type},on:{"change":function($event){return _vm.closeList()}}},_vm._l((_vm.list),function(item){return _c('option',{key:item.id,attrs:{"id":item.id},domProps:{"value":item.id},on:{"click":function($event){return _vm.setValue(item.id, item.value)}}},[_vm._v("\n        "+_vm._s(item.value)+" \n      ")])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }